module.exports = __webpack_public_path__ + "img/system.44d3ffb7.png";